import Swal from "sweetalert2";
import { formatDate } from "./formatDate";

// Update Management Review record in Zoho Creator
export const updateMRRecord = async (recordId, updateData) => {
  console.log("updateMRRecord called with:", { recordId, updateData });

  if (!recordId) {
    console.error("No recordId provided to updateMRRecord");
    Swal.fire({
      title: "Update Failed",
      text: "No record ID provided for update.",
      icon: "error",
      confirmButtonText: "OK",
    });
    return false;
  }

  const conn_name = "crmwidgetconnection";
  const apiUrl = `https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/Management_Review_Report/${recordId}`;

  // Map updateData to Zoho Creator field names for Management Review
  const formattedData = {};

  // Basic fields
  if (updateData.status !== undefined) {
    formattedData.Status = updateData.status;
    formattedData.status = updateData.status;
  }
  if (updateData.noteTaker !== undefined)
    formattedData.Note_taker_for_this_Management_Review = updateData.noteTaker;

  // Dates
  if (updateData.date)
    formattedData.Date_of_this_Management_Review = formatDate(
      new Date(updateData.date)
    );
  if (updateData.previousDate)
    formattedData.Date_of_previous_Management_Review = formatDate(
      new Date(updateData.previousDate)
    );

  // Agenda items from section 1
  if (updateData.agendaItems?.a !== undefined)
    formattedData.a1 = updateData.agendaItems.a;
  if (updateData.agendaItems?.b !== undefined)
    formattedData.b1 = updateData.agendaItems.b;
  if (updateData.agendaItems?.c !== undefined)
    formattedData.c1 = updateData.agendaItems.c;

  // Agenda items from section 2
  if (updateData.agendaItems?.businessPerformance !== undefined)
    formattedData.a2 = updateData.agendaItems.businessPerformance;
  if (updateData.agendaItems?.internalAuditResults !== undefined)
    formattedData.b2 = updateData.agendaItems.internalAuditResults;
  if (updateData.agendaItems?.supplierPerformance !== undefined)
    formattedData.c2 = updateData.agendaItems.supplierPerformance;
  if (updateData.agendaItems?.resourceAdequacy !== undefined)
    formattedData.d2 = updateData.agendaItems.resourceAdequacy;
  if (updateData.agendaItems?.maintenanceIssues !== undefined)
    formattedData.e2 = updateData.agendaItems.maintenanceIssues;
  if (updateData.agendaItems?.customerFeedback !== undefined)
    formattedData.f2 = updateData.agendaItems.customerFeedback;

  // Agenda items from sections 3-5
  if (updateData.agendaItems?.risks !== undefined)
    formattedData.a3 = updateData.agendaItems.risks;
  if (updateData.agendaItems?.opportunities !== undefined)
    formattedData.a4 = updateData.agendaItems.opportunities;
  if (updateData.agendaItems?.businessUpdates !== undefined)
    formattedData.a5 = updateData.agendaItems.businessUpdates;

  // Recap items from section 6
  if (updateData.agendaItems?.recapItemA !== undefined)
    formattedData.a6 = updateData.agendaItems.recapItemA;
  if (updateData.agendaItems?.recapItemB !== undefined)
    formattedData.b6 = updateData.agendaItems.recapItemB;
  if (updateData.agendaItems?.recapItemC !== undefined)
    formattedData.c6 = updateData.agendaItems.recapItemC;

  // Log the formatted data being sent to the API
  console.log("Sending formatted MR data to API:", formattedData);

  const payload = {
    parameters: {
      data: formattedData,
    },
    method: "PATCH",
    url: apiUrl,
    param_type: 2,
  };

  try {
    console.log("Sending request to ZOHO.CRM.CONNECTION.invoke for MR update");
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);
    console.log("MR Update Response:", response);

    if (response && response.code === "SUCCESS") {
      return true;
    } else {
      const errorMsg = response?.message || "Unknown error occurred.";
      console.error("API error response for MR update:", errorMsg);

      Swal.fire({
        title: "Update Failed",
        text: errorMsg,
        icon: "error",
        confirmButtonText: "OK",
      });
      return false;
    }
  } catch (err) {
    console.error("MR Update error:", err);

    Swal.fire({
      title: "Error",
      text: `An error occurred while updating the Management Review: ${
        err.message || "Unknown error"
      }`,
      icon: "error",
      confirmButtonText: "OK",
    });
    return false;
  }
};
